import { LoadableAfterPaint } from '@confluence/loadable';
import { fg } from '@confluence/feature-gating';

export const KeyboardShortcutsDialog = LoadableAfterPaint<any>({
	loader: async () => {
		if (fg('confluence_frontend_new_keyboard_shortcut_dialog')) {
			return (
				await import(
					/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './NewKeyboardShortcutsDialog'
				)
			).KeyboardShortcutsDialog;
		} else {
			return (
				await import(
					/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './KeyboardShortcutsDialog'
				)
			).KeyboardShortcutsDialog;
		}
	},
});

export { KeyboardShortcutsDialogQuery } from './KeyboardShortcutsDialogQuery.experimentalgraphql';
